import {FC, useEffect, useRef, useCallback, ReactNode} from 'react';

interface Props {
  children: ReactNode,
  onOutsideClick: (e: MouseEvent) => void,
  className?: string,
}

const OnOutsideClick: FC<Props> = ({onOutsideClick, className, children}) => {
  const ref = useRef<HTMLDivElement>(null);

  // make sure the click function never changes
  const handleClick = useCallback((e: MouseEvent) => {
    if (!ref.current.contains(e.target as HTMLDivElement)) {
      onOutsideClick(e);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}

export default OnOutsideClick;
